<template>
    <div class="pc-news" id="pc-news">

        <div class="header-wrap" id="header-wrap-id">
            <transition name="fade">
            <div class="nav" v-show="showNav">
                <ul>
                    <li><a href="/explore/xfz2017/" target="_blank">首页</a></li>
                    <li><a href="/explore/xfz2017/#s-guest" target="_blank">参会嘉宾</a></li>
                    <li><a href="/explore/xfz2017/#s-agenda" target="_blank">会议议程</a></li>
                    <li><a href="/explore/xfz2017/#s-tickets" target="_blank">参会购票</a></li>
                    <li><a href="/explore/xfz2017/#s-partners" target="_blank">合作机构</a></li>
                    <li><a href="/explore/xfz2017/#s-location" target="_blank">场地信息</a></li>
                    <li><a href="/explore/xfz2017/#s-contact-us" target="_blank">联系我们</a></li>
                </ul>
            </div>
            </transition>
        </div>
        <div class="pc-news-wrap">
            <!-- 大会回顾视频 -->
            <div class="section live">
                <div class="live-title"><img src="../assets/images/video-pc.png" alt=""></div>
                <div class="section course">
                    <div class="section course">
                        <div class="course-wrap">
                            <div class="course-title">未来创新专场</div>
                            <div class="course-items-wrap">
                            <div class="course-area">
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/178.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513063811_824.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">华尔街十年巨变：中国创新力量的崛起</div>
                                        <div class="info-author">吉姆·罗杰斯/量子基金创办人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/179.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513065034_406.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">研判2018：创投新战场</div>
                                        <div class="info-author">李黎/嘉程资本创始合伙人、小饭桌创始人； 张颖/经纬中国创始管理合伙人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/180.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513065071_142.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">共享单车与城市</div>
                                        <div class="info-author">张巳丁/ofo小黄车联合创始人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/181.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513066076_626.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">金融“大”玩家</div>
                                        <div class="info-author">郭晨凯/韬映资本董事总经理；吉姆·罗杰斯/量子基金基金创办人 </div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/182.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513066148_85.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">做时间的朋友</div>
                                        <div class="info-author">脱不花/得到App联合创始人兼CEO </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="course-wrap">
                            <div class="course-title">未来智慧专场</div>
                            <div class="course-items-wrap">
                            <div class="course-area">
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/183.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513066172_946.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">微软：将AI赋予每一个企业</div>
                                        <div class="info-author">于伟/微软全球合伙人、微软亚太研发集团工程院副院长</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/184.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513066370_185.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">Innovation in Intelligent Systems</div>
                                        <div class="info-author">Yosi Lahad/Co-Founder of NextWave Robotics</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/185.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513066402_508.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">语音唤醒万物：语音与自然语言处理</div>
                                        <div class="info-author">谢冠超/云知声IOT事业部总裁</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/186.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513648493_271.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">AI 赋能：深度学习处理器与多场景AI应用</div>
                                        <div class="info-author">汪玉/深鉴科技联合创始人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/187.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513067515_281.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">人工智能物质载体：深度学习处理器</div>
                                        <div class="info-author">钱诚/寒武纪副总裁</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/188.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513068771_16.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">自动驾驶让道路出行更美好</div>
                                        <div class="info-author">黄畅/地平线联合创始人兼算法副总裁</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/189.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513073996_456.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">科技落地生根：AI如何+行业？</div>
                                        <div class="info-author">主持：张一甲 ,科技智库甲子光年创始人兼CEO</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="course-wrap">
                            <div class="course-title">未来消费专场</div>
                            <div class="course-items-wrap">
                            <div class="course-area">
                                <!-- <div class="course-item">
                                    <a href="http://www.xfz.cn/course/190.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074025_156.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">“信用+”是下一个十年最大的商业红利</div>
                                        <div class="info-author">徐惠/蚂蚁金服芝麻信用首席产品架构师</div>
                                        </div>
                                    </a>
                                </div> -->
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/191.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074060_532.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">文娱淘金 漫画开启新时代</div>
                                        <div class="info-author">陈安妮/快看漫画创始人兼CEO</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/192.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074088_956.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">即时消费将是新零售最大风口  大数据时代如何精准重构“人-场-货”</div>
                                        <div class="info-author">司江华/猩便利联合创始人兼总裁</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/193.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074115_897.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">开启办公场景革命的新格局</div>
                                        <div class="info-author">张剑/纳什空间创始人兼CEO</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/194.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074138_654.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">消费新势能</div>
                                        <div class="info-author">刘锐/天使之橙、Vingoo维果部落联合创始人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/195.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074316_971.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">未来消费：如何把握潮水的方向</div>
                                        <div class="info-author">主持人：曲凯，42章经创始人</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="course-wrap">
                            <div class="course-title">未来科技金融专场</div>
                            <div class="course-items-wrap">
                            <div class="course-area">
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/197.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074335_754.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">金融科技创新引领普惠金融发展</div>
                                        <div class="info-author">吴逖/众安保险副总经理兼CMO</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/198.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513648695_27.jpg-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">科技赋能场景保险</div>
                                        <div class="info-author">汤鹏/量子保创始人</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/199.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074402_194.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">科技让保险更主动</div>
                                        <div class="info-author">陈龙/大象保险CTO</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/200.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074430_204.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">Fintech时代的美港股投资</div>
                                        <div class="info-author">巫天华/老虎证券创始人兼CEO</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/201.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074473_908.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">科技让金融更美好</div>
                                        <div class="info-author">主持人：陈一佳 , 路透财经评论员</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/203.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513075126_301.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">Fintech Evolution in India</div>
                                        <div class="info-author">Madhu, CEO of KrazyBee</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="course-item">
                                    <a href="http://www.xfz.cn/course/202.html" target="_blank">
                                        <div class="info-logo"><img src="http://static-image.xfz.cn/1513074496_627.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                                        <div class="info-content">
                                        <div class="course-item-title">巴西的金融科技崛起趋势</div>
                                        <div class="info-author">主持人：谢荫智, CBIPA中巴互联网促进会CEO</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="live-title">
                    <img src="../assets/images/p-news.png" alt="">
                    <div class="refresh" @click="refreshContent()"> 刷新 </div>
                </div>
            </div>
            <!-- 新闻列表 -->
            <div class="pc-news-list">
                <div class="news-list-wrap">
                    <div class="title-area" v-if="false">
                        <div class="title">大会新闻</div>
                        <div class="refresh" @click="refreshContent()">
                            <img src="../assets/icon-refresh.png" alt=""> 刷新
                        </div>
                    </div>
                    <template  v-for="item in newsData">
                        <pc-news-item  :news="item"></pc-news-item>
                    </template>
                    <template v-if="newsData.length == 0">
                        <div style="width:200px; text-align:center; margin: 20px auto; font-size:22px;">暂无新闻</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PcNewsItem from './PcNewsItem.vue'
import util from '../assets/js/util'
import liveData from '../assets/js/livedata.js'

export default{
    components:{ PcNewsItem },
    data(){
        return{
            showNav: true,
            newsData: [],
            liveData: [],
            // todo delete
            newDataFake:{
                "code": 200,
                "data": [
                    {
                        "tread": 0,
                        "like": 0,
                        "title": "第四篇文章1",
                        "photo": "http://static-image.xfz.cn/1489643700_594.png",
                        "author": {
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "name": "刘星 王自力 小妹"
                        },
                        "is_original": false,
                        "article_type": " 海外投资报告",
                        "intro": "22",
                        "source": "小饭桌1",
                        "time": "2017-03-16 13:55:00",
                        "keywords": [
                            "马克思",
                            "金融",
                            "大米"
                        ],
                        "author_member": {
                            "uid": "",
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "company": "小饭桌",
                            "work": "fa",
                            "article_count": 4,
                            "signature": "介绍",
                            "author_id": 23,
                            "email": "xing@xfz.cn",
                            "realname": "刘星"
                        },
                        "uid": 71
                    },
                    {
                        "tread": 0,
                        "like": 0,
                        "title": "第三篇测试",
                        "photo": "http://static-image.xfz.cn/1489643369_417.png",
                        "author": {
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "name": "刘星"
                        },
                        "is_original": false,
                        "article_type": "原创",
                        "intro": "哈哈",
                        "source": "xioafanz",
                        "time": "2017-03-16 13:49:29",
                        "keywords": [],
                        "author_member": {
                            "uid": "",
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "company": "小饭桌",
                            "work": "fa",
                            "article_count": 4,
                            "signature": "介绍",
                            "author_id": 23,
                            "email": "xing@xfz.cn",
                            "realname": "刘星"
                        },
                        "uid": 70
                    }
                ]
            }
        }
    },
    methods:{
        addListenScroll(){
            var self = this
            window.onscroll = function (e) {
                var h_scrolled = document.body.scrollTop;
                // top nav
                if(h_scrolled > 500 ){
                   self.showNav = false;
                } else {
                   self.showNav = true;
                }
            }
        },
        getNewsListFake(){
            this.newsData = this.newDataFake.data
        },
        getNewsList() {

            var self = this
            util.resource({
                url: '/api/website/articles/?tag=2017小饭桌全球青年创业者大会&n=1000&p=1',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.newsData = res.data
                    }
                }
            })
        },
        refreshContent(){
            this.newsData = []
            this.getNewsList()
        }
    },
    mounted(){
        this.liveData = liveData
        this.addListenScroll()
        this.getNewsList()
        // this.getNewsListFake()
        util.getWx()
    }
}
</script>
<style lang="scss">
#pc-news {
    font-size: 14px;
    min-width: 1100px;
    min-height: 200px;
    // background-image: url(http://static-image.xfz.cn/explore/xfz2017/bg-dot.png);
    background-color: black;

    .pc-news-wrap {
        width: 1100px;
        margin: 0 auto;
    }
    .header-wrap{
        height: 550px;
        background:{
            image: url('../assets/images/p-banner.png');
            repeat: no-repeat;
            position: center;
        }
        .nav{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 3;
            right: 0;
            text-align: right;
            background-color: rgba(0,0,0,.3);
            line-height: 50px;
            ul {
                width: 1170px;
                margin: 0 auto;
                display: block;
                li {
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 18px;
                    display: inline-block;
                    list-style: none;
                    padding: 0 10px;
                    color: #fff;
                    a {
                        text-decoration: none;
                        color: #fff;
                    }
                    &:hover {
                        a{
                            color: #fff;
                            border-bottom: 4px solid #556fb5;
                            padding-bottom: 11px;
                            color: #fff;
                        }
                    }
                }
                .active{
                    background-color: #0079cf;
                }
            }
        }
        .logo{
            padding-top:90px;
            max-width: 200px;
            margin: 0 auto;
            margin-bottom: 90px;
            img{
                width: 216px;
            }
        }
        .conf-name{
            width: 100%;
            text-align: center;
            color: #fff;
            .name-main{
                font-size: 76px;
                font-weight: bold;
                margin-bottom: 5px;
            }
            .name-sub{
                font-size: 38px;
                margin-bottom: 90px;
            }
            .hotel{
                font-size: 24px;
            }
        }
    }
    // 大会回顾视频
    .course {
        a {
            text-decoration: none;
        }
        margin-top: 30px;
        margin-bottom: 30px;
        .course-wrap {
            width: 1100px;
            margin: 0 auto;
            padding-bottom: 10px;
            background: #f2f2f2;
            .course-title {
                font-size: 46px;
                color: #042745;
                width: 1100px;
                padding-left: 40px;
                padding-top: 15px;
            }
            .course-items-wrap {
                text-align: center;
                // margin-bottom: 20px;
                .course-area {
                    display: block;
                    overflow: hidden;
                    margin: 20px 25px 0 25px;
                    .course-item {
                        float: left;
                        margin: 0 10px 20px;
                        width: 242px;
                        .info-logo {
                            max-height: 146px;
                            overflow: hidden;
                            position: relative;
                            font-size: 0;
                            img {
                                width: 100%;
                            }
                            .tags {
                                display: inline-block;
                                width: 50px;
                                height: 50px;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-top: -25px;
                                margin-left: -25px;
                                background: url(http://static-image.xfz.cn/player-latest-icon.png);
                            }
                        }
                        .info-content {
                            box-sizing: border-box;
                            padding: 15px;
                            background: #fff;
                            .course-item-title {
                                font-size: 16px;
                                text-align: left;
                                color: dimgray;
                                line-height: 26px;
                                height: 52px;
                                overflow: hidden;
                            }
                            .info-author {
                                text-align: left;
                                line-height: 34px;
                                font-size: 14px;
                                color: #9b9b9b;
                                height: 34px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }
    .live{
        margin-top: 60px;
        margin-bottom: 30px;
        .live-wrap{
            width: 1100px;
            margin: 0 auto;
            .live-items-wrap{
                text-align:center;
                margin: 30px 0;
                img {
                    margin-right: 20px;
                }
            }
            .tuwen-live {
                margin-left: 30px;
                margin-bottom: 30px;
                span {
                    display: inline-block;
                    // border: 1px solid #fff;
                    font-size: 30px;
                    color: #fff;
                    font-weight: bold;
                    vertical-align: top;
                    margin-right: 50px;
                }
            }
        }
        .live-title{
            margin-top: 20px;
            .refresh {
                float: right;
                color: #fff;
                font-size: 30px;
                cursor: pointer;
            }
        }
        .middle-diveder {
            height: 2px;
            margin: 40px 25px 30px;
            background-repeat: no-repeat;
            background-image: url('../assets/images/divider-line.png');
        }
        .live-sub-title {
        	font-weight: bold;
            padding-left: 20px;
        	font-stretch: normal;
        	line-height: 45px;
        	letter-spacing: 3px;
        	color: #ffffff;
        	font-size: 30px;
            margin-top: 40px;
            span {
                display: inline-block;
            }
            .title {
                background-image: url('../assets/images/half-red-bg.png');
                height: 30px;
                line-height: 30px;
            }
            .time {
                font-size: 24px;
                margin-right: 20px;
            }
        }
        .live-area{
            margin: 20px;
        }
        .date-title{
            // width: 1150px;
            margin: 0 auto;
            text-align: left;
            font-size: 24px;
            color:#0047ca;
            margin-top:10px;
        }
        .live-item{
            display: inline-block;
            margin: 0 10px;
            width: 260px;
            border: 2px solid #1a74bf;
            .live-name{
                font-size: 24px;
                color: #0047ca;
                padding:6px;
                background-color: #1a74bf;
                a{
                    font-weight: bold;
                    text-decoration: none;
                    color: #fff;
                }
            }
            .live-links{
                // background-color: #0047ca;
                background-color: #fff;
                a{
                    text-decoration: none;
                    color: #1a74bf;
                }
                .link-item{
                    font-size: 22px;
                    font-weight: bold;
                    display: inline-block;
                    color: #fff;
                    padding: 4px 20px;
                }
                .link-divider{
                    display: inline-block;
                    font-size: 19px;
                    width: 2px;
                    color: #1a74bf;
                    background-color: #1a74bf;
                }
            }
        }
    }

    .pc-news-list{
        padding-bottom: 100px;
        .news-list-wrap{
            width: 1100px;
            margin: 0 auto;
            background-color: #fff;
            padding: 20px;
            .title-area{
                width: 1000px;
                margin: 20px auto;
                color: #042745;
                .title{
                    display: inline-block;
                    font-size: 46px;
                }
                .refresh{
                    display: inline-block;
                    font-size: 30px;
                    float: right;
                    cursor: pointer;
                }
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// PcNews.vue?223755ba